module.exports = __webpack_public_path__ + "img/病房.ea729b7d.png";